module.exports = __webpack_public_path__ + "img/watercolor_white.ec6d011.svg";